/** @format */

const ApiGroup = {
  getProductList: '/monitor/?Action=DescribeMonitorProductList&Version=2021-01-01', // 获取产品列表UIC接口
  // 查看资源分组列表
  getGroupList: '/monitor/?Action=DescribeInstanceGroupList&Version=2021-01-01',
  // 获取资源分组列表（新）
  getResourceGroupList: '/monitor/?Action=DescribeResourceGroupList&Version=2021-01-01',
  // 修改资源分组名称
  modifyGroupName: '/monitor/?Action=ModifyResourceGroup&Version=2021-01-01',
  // 创建资源分组
  createGroup: '/monitor/?Action=CreateResourceGroup&Version=2021-01-01',
  // 删除资源分组
  deleteGroup: '/monitor/?Action=DeleteResourceGroup&Version=2021-01-01',
  // 复制资源分组
  copyGroup: '/monitor/?Action=CopyResourceGroup&Version=2021-01-01',
  // 获取资源分组下产品列表
  getGroupProducts: '/monitor/?Action=DescribeResourceGroupProducts&Version=2021-01-01',
  // 获取资源分组关联资源列表（productType）
  getGroupProductInstances: '/monitor/?Action=DescribeResourceGroupInstances&Version=2021-01-01',
  // 获取实例组关联资源列表（老）
  getGroupInstanceList: '/monitor/?Action=DescribeInstanceGroupResources&Version=2021-01-01',
  // 设置资源分组产品线动态匹配规则
  setGroupProductRules: '/monitor/?Action=PutResourceGroupDynamicRule&Version=2021-01-01',
  // 资源分产品线添加实例
  addGroupProductInstance: '/monitor/?Action=CreateResourceGroupInstances&Version=2021-01-01',
  // 资源分组产品线移除实例
  removeGroupProductInstance: '/monitor/?Action=DeleteResourceGroupInstances&Version=2021-01-01',
  // 资源分组移出产品线
  removeGroupProduct: '/monitor/?Action=DeleteResourceGroupProduct&Version=2021-01-01'
}
export default ApiGroup
